import { HW_APP_TYPE } from "../consts/HardwareConstants";

export const isSoftwareItemDisabled = (appType?: string | null) =>
	appType ? appType === HW_APP_TYPE : true;
